import {
  MANAGEMENT_OFFICE_TYPE,
  SUB_MANAGEMENT_OFFICE_TYPE,
  INSTALLATION_OFFICE_TYPE,
  OPERATION_OFFICE_TYPE,
  DEPARTMENT_OFFICE_TYPE
} from "@/services/consts"
import i18n from "@/lang/i18n";

export const MANAGER_ROLE_ID = 1;
export const DRIVER_ROLE_ID = 2;
export const DEFAULT_SELECTED_OFFICE = {
  id: null,
  type: "",
  name: "",
  departments: [],
  authorities: [],
};

export const BLANK_OFFICEABLE_TYPE = { id: null, name: null, type: null }

export const MANAGEMENT_OFFICE = {
  id: 1,
  name: i18n.global.t('pages.accounts.managementOffice'),
  type: MANAGEMENT_OFFICE_TYPE.split("\\")[2]
}

export const SUB_MANAGEMENT_OFFICE = {
  id: 2,
  name: i18n.global.t('pages.accounts.subManagementOffice'),
  type: SUB_MANAGEMENT_OFFICE_TYPE.split("\\")[2]
}

export const INSTALLATION_OFFICE = {
  id: 3,
  name: i18n.global.t('pages.accounts.installationOffice'),
  type: INSTALLATION_OFFICE_TYPE.split("\\")[2]
}

export const OPERATION_OFFICE = {
  id: 4,
  name: i18n.global.t('pages.accounts.operationOffice'),
  type: OPERATION_OFFICE_TYPE.split("\\")[2]
}

export const DEPARTMENT = {
  id: 5,
  name: i18n.global.t('pages.accounts.department'),
  type: DEPARTMENT_OFFICE_TYPE.split("\\")[2]
}

export const BLANK_ROLE = { name: '', value: null }

export const ROLES = [
  { name: i18n.global.t('pages.accounts.administrator'), value: MANAGER_ROLE_ID },
  { name: i18n.global.t('pages.accounts.driver'), value: DRIVER_ROLE_ID },
]

export const INVALID_ACCOUNT_PROPS = [
  "status",
  "created_at",
  "created_by",
  "deleted_at",
  "updated_at",
  "updated_by",
  "group_id",
  "login_times",
  "sub",
  "synced_at",
  "email_verified_at",
  "department",
  "department_target_name",
  "pwd_last_updated_at",
  "lang",
]
